/** @format */

import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, CardContent } from '@mui/material';
import { Person, ExitToApp } from '@mui/icons-material';
import { Avatar } from 'src/components/header/avatar';
import useAuth from 'src/hooks/useAuth';
import { useSelector } from 'src/store';
import Breadcrumb from 'src/components/Breadcrumb';
import Page from 'src/components/Page';
import { Button } from 'src/components';
import { useNavigate } from 'react-router-dom';
import { getPrimaryCapitalizedRole, getScenarioLabel } from 'src/utils/helper';

const Profile = () => {
  const { user } = useAuth();
  const { userProfile } = useSelector(state => state.users);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const role = useMemo(() => {
    if (!user || Object.keys(user).length === 0) {
      return '';
    }

    if (user.scenario) {
      return getScenarioLabel(String(user.scenario), t);
    }

    const roleFromRoles = getPrimaryCapitalizedRole(user.roles);
    if (roleFromRoles) {
      const roleKey = `profile.role.${roleFromRoles}`;
      const translated = t(roleKey);
      return translated === roleKey ? roleFromRoles : translated;
    }

    return 'Standard';
  }, [user, t]);

  return (
    <Page title={t('profile.title')}>
      <section className="main_content profile">
        <Breadcrumb data={[{ title: t('profile.title') }]} additionalClasses="container--narrow" />

        <div className="container container--narrow">
          <h2 className="page_title">{t('profile.title')}</h2>

          <Grid container className="profile__grid" spacing={2}>
            <Grid item xs={12} lg={6}>
              <CardContent className="profile__card">
                <Grid container className="profile__card-head" spacing={2}>
                  <Grid item>
                    <Person fontSize="large" />
                  </Grid>
                  <Grid item>
                    <strong>{t('common.personalData')}</strong>
                  </Grid>
                </Grid>
                <Grid container spacing={4} alignItems="center">
                  <Grid item className="profile_pic">
                    <Avatar srcImg={userProfile?.picture || ''} name={`${user?.firstName} ${user?.lastName}`} />
                  </Grid>
                  <Grid item>
                    <p>{user && user.firstName && `${user?.firstName} ${user?.lastName}`}</p>
                    <span className="title">{role}</span>
                  </Grid>
                </Grid>
                <Button label={t('profile.cta')} text arrow onClick={() => navigate('/personaldata')} />
              </CardContent>
            </Grid>
            <Grid item xs={12} lg={6}>
              <CardContent className="profile__card">
                <Grid container className="profile__card-head" spacing={2}>
                  <Grid item>
                    <ExitToApp fontSize="large" />
                  </Grid>
                  <Grid item>
                    <strong>{t('common.access')}</strong>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item xs={12}></Grid>
                </Grid>
                <Button label={t('profile.cta')} text arrow onClick={() => navigate('/access')} />
              </CardContent>
            </Grid>
          </Grid>
        </div>
      </section>
    </Page>
  );
};

export { Profile };
